import {useState, MouseEvent, useCallback} from 'react';
import classNames from 'classnames';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import ListOptionsItem, {ListOptionConfig} from './ListOptionsItem';

type ListOptionsProps = {
  options: Dictionary<ListOptionConfig>,
  position?: 'horizontal' | 'vertical',
  size?: 'small' | 'medium'
}

const ListOptions = ({
  options, position, size = 'medium'
}: ListOptionsProps) => {
  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLElement>>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <div className="menu">
      <IconButton
        onClick={handleOpen}
        className={classNames('icon-button', size, {'active': open})}
      >
        {position === 'vertical' ? (
          <MoreVertIcon className="icon" fontSize={size} />
        ) : (
          <MoreHorizIcon className="icon" fontSize={size} />
        )}
      </IconButton>

      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        disablePortal
        classes={{
          list: 'menu__list'
        }}
        disableScrollLock={false}
      >
        {Object.values(options).map((option) => (
          <ListOptionsItem
            {...option}
            handleClose={handleClose}
            key={option.name}
          />
        ))}
      </Menu>
    </div>
  );
};

export default ListOptions;
